import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]




export default /*#__PURE__*/_defineComponent({
  __name: 'AppLink',
  props: {
  url: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: props.url,
    target: "_blank",
    class: "break-all underline decoration-dotted underline-offset-4"
  }, _toDisplayString(props.url), 9, _hoisted_1))
}
}

})